export const selectedIngredientUnit = (itemId: string | number | null | undefined, unit?: string): string => {
    const selected = typeof itemId === 'string' ? itemId.length > 0 : typeof itemId === 'number' && itemId >= 0;
    return selected ? unit ?? '' : '';
};
